import { PAGE_SIZE } from './../globalConstants'

export default {
    methods: {
        calculateNumberOfPages: function (numberOfElements) {
            return Math.ceil(numberOfElements / PAGE_SIZE);
        }
    }
}